import Modal from "../../ui-components/Modal";
import useCountryAxiosInstance from "../../hooks/useCountryAxiosInstance";
import Button from "../../ui-components/Button";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";

function WorksiteDeleteModal({
  closeModal,
  selectedWorksite,
  toggleDeleteWorksiteDialog,
  countryCode,
}) {
  const apiRequest = useCountryAxiosInstance();
  const { push } = useHistory();

  const deleteWorksite = async () => {
    let cancel = false;
    try {
      await Promise.all([
        apiRequest.delete(`/worksites/${selectedWorksite.id}`),
      ]);
      push("/" + countryCode + "/worksites");
      if (!cancel) {
        toggleDeleteWorksiteDialog();
      }
    } catch (error) {
      if (!cancel) {
        console.log("errore", error);
      }
    }
  };

  return (
    <Modal onExit={closeModal}>
      <div className="flex w-full flex-col h-full items-center justify-center">
        <label className="ml-2 block text-m text-black-500">
          <FormattedMessage id="confirm_worksite_deletion" />
        </label>
        <div className="w-full mt-4 flex justify-center">
          <Button variant="contained" color="primary" onClick={deleteWorksite}>
            <FormattedMessage id="delete" />
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default WorksiteDeleteModal;
